<template>
    <CodiceFeanorView tool-module="kdf" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
